import { Button } from '@/components/ui/button'
import { Text } from '@/components/ui/text'
import { RotateCcw } from 'lucide-solid'
import { Grid } from 'styled-system/jsx'

export const Scan = (props: {
  onScan: () => void
  onReset: () => void
  isDisabled: boolean
  isLoading: boolean
  isDetecting?: boolean
}) => {
  return (
    <Grid
      px={6}
      gap={2}
      alignItems="center"
      gridTemplateColumns={{
        base: '1fr auto auto',
        mdDown: '1fr',
      }}
    >
      <Text>
        {props.isDetecting
          ? 'Finding the HVF data in the top right of the chart...'
          : 'The HVF data in the top right is selected automatically. Adjust the crop area if needed, then click Extract to scan the details.'}
      </Text>
      <Button
        loading={props.isLoading}
        colorPalette="jade.10"
        onClick={props.onScan}
        disabled={props.isDisabled}
      >
        Extract HVF Details
      </Button>
    </Grid>
  )
}
